export enum Language {
  ENGLISH = 'en-US',
  FRENCH = 'fr-FR',
  SPANISH = 'es-ES',
  GERMAN = 'de-DE',
  ITALIAN = 'it-IT',
}

export type Locale = 'fr' | 'en' | 'es' | 'de' | 'it' | 'fr-FR' | 'en-US' | 'en-GB' | 'de-DE' | 'es-ES' | 'it-IT';
